import { componentStyle } from '@/styling/util/component-style.ts';

export const paginatorStyle = componentStyle({
    navButtonSelectedBackground: '{button.primary.background}',
    navButtonSelectedColor: '{button.primary.color}',
    navButtonBorderRadius: '{border.radius.sm}',
});
